/*!
  Machina, by Koding Themes
  accessibility.js
  https://kodingthemes.com
*/

function getFocusableElements(container) {
   return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled"));
}
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
   var elements = getFocusableElements(container);
   var first = elements[0];
   var last = elements[elements.length - 1];
   removeTrapFocus();
   trapFocusHandlers.focusin = (event) => {
      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener("keydown", trapFocusHandlers.keydown);
   };
   trapFocusHandlers.focusout = function() {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
   };
   trapFocusHandlers.keydown = function(event) {
      if (event.code.toUpperCase() !== "TAB") return;
      if (event.target === last && !event.shiftKey) {
         event.preventDefault();
         first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
         event.preventDefault();
         last.focus();
      }
   };
   document.addEventListener("focusout", trapFocusHandlers.focusout);
   document.addEventListener("focusin", trapFocusHandlers.focusin);
   elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
   document.removeEventListener("focusin", trapFocusHandlers.focusin);
   document.removeEventListener("focusout", trapFocusHandlers.focusout);
   document.removeEventListener("keydown", trapFocusHandlers.keydown);
   if (elementToFocus) elementToFocus.focus();
}

document.addEventListener("DOMContentLoaded", function() {
   [...document.querySelectorAll("a[target=_blank]")].forEach(function(item) {
      item.setAttribute("rel", "noopener noreferrer");
   });
   document.querySelectorAll(".ss-list").forEach(function(select) {
      select.setAttribute("aria-label", "choose-option");
   });

   var sidebar = document.querySelectorAll(".js-menu-toggle");
   var addToCartBtn = document.querySelector(".add-to-cart-button");

   if (sidebar != null) {
      sidebar.forEach(function(item) {
         item.addEventListener("click", function() {
            var sidebarEl = document.querySelector("aside.sidebar");
            if (sidebarEl) {
               sidebarEl.setAttribute("tabindex", 0);
               sidebarEl.focus();
            }
         });
      });
   }

   if (addToCartBtn != null) {
      addToCartBtn.addEventListener("click", function() {
         var sidebarEl = document.querySelector("aside.sidebar");
         if (sidebarEl) {
            sidebarEl.focus();
         }
      });
   }
});

document.addEventListener("keydown", function(event) {
   var activeElement = document.activeElement;
   if (event.shiftKey && event.key === "Tab") {
      var cartSelector = document.querySelectorAll("#cart").length > 0
         ? "#page-cart-inner #cart-fieldset .cart-items>.line-item"
         : "#cart-fieldset .cart-items>.line-item";
      document.querySelectorAll(cartSelector).forEach(function(selfClass) {
         var removeBtn = selfClass.querySelector(".remove-lines");
         if (removeBtn === activeElement) {
            event.preventDefault();
            selfClass.querySelector(".line-image a").focus();
         }
      });
   }
   if (event.key === "Tab" && !event.shiftKey) {
      if (document.querySelectorAll("#product").length > 0) {
         var doc1 = activeElement;
         var doc2 = document.querySelector(".featured-products>.collection-toggle:last-child .add-to-cart-button");
         if (doc1 === doc2) {
            event.preventDefault();
            document.querySelector(".main-featured-products .glider-prev").focus();
         }
         var doc3 = document.querySelector(".main-featured-products .glider-prev");
         if (doc1 === doc3) {
            event.preventDefault();
            document.querySelector(".main-featured-products .glider-next").focus();
         }
         var doc4 = document.querySelector(".section-product-tabs .nav-tabs .nav-item:last-child .nav-link");
         if (doc1 === doc4) {
            var recPrev = document.querySelector(".product-recomendations-section .controls-rec .glider-prev");
            if (recPrev) {
               event.preventDefault();
               recPrev.focus();
            }
         }
         var doc5 = document.querySelector(".product-recomendations-section .controls-rec .glider-prev");
         if (doc1 === doc5) {
            var recNext = document.querySelector(".product-recomendations-section .controls-rec .glider-next");
            if (recNext) {
               event.preventDefault();
               recNext.focus();
            }
         }
         var doc6 = document.querySelector(".product-recomendations-section .controls-rec .glider-next");
         if (doc1 === doc6) {
            var recFirst = document.querySelector("#product_recomendation_body .rec-products:first-child .product-details-card a");
            if (recFirst) {
               event.preventDefault();
               recFirst.focus();
            }
         }
         var doc6b = document.querySelector("#product_recomendation_body .rec-products:last-child .product-thumb");
         if (doc1 === doc6b) {
            var recentPrev = document.querySelector(".recently-viewed-section .controls .glider-prev");
            if (recentPrev) {
               event.preventDefault();
               recentPrev.focus();
            }
         }
         var doc7 = document.querySelector(".recently-viewed-section .controls .glider-prev");
         if (doc1 === doc7) {
            var recentNext = document.querySelector(".recently-viewed-section .controls .glider-next");
            if (recentNext) {
               event.preventDefault();
               recentNext.focus();
            }
         }
         var doc9 = document.querySelector(".recently-viewed-section .controls .glider-next");
         if (doc1 === doc9) {
            var recentFirst = document.querySelector(".recently_viewed_products2>div:first-child .product-details-card a");
            if (recentFirst) {
               event.preventDefault();
               recentFirst.focus();
            }
         }
         var doc10 = document.querySelector(".recently_viewed_products2>div:last-child .product-thumb");
         if (doc1 === doc10) {
            var footerFirst = document.querySelector(".footer-top #accordion .links-list .footer-menu:first-child a");
            if (footerFirst) {
               event.preventDefault();
               footerFirst.focus();
            }
         }
         var doc11 = document.querySelector("#MainContent");
         if (doc1 === doc11) {
            var sliderPrevBtn = document.querySelector(".product-medaia-slider-controls .glider-prev");
            if (sliderPrevBtn) {
               event.preventDefault();
               sliderPrevBtn.focus();
            } else {
               var slideLink = document.querySelector(".product-images .slides div a");
               if (slideLink) {
                  event.preventDefault();
                  slideLink.focus();
               }
            }
         }
         var doc12 = document.querySelector(".product-medaia-slider-controls .glider-prev");
         if (doc1 === doc12) {
            var activeSlide = document.querySelector(".js-slides .tns-slide-active a");
            if (activeSlide) {
               event.preventDefault();
               activeSlide.focus();
            }
         }
         var doc13 = document.querySelector(".js-slides .tns-slide-active a");
         if (doc1 === doc13) {
            var sliderNextBtn = document.querySelector(".product-medaia-slider-controls .glider-next");
            if (sliderNextBtn) {
               event.preventDefault();
               sliderNextBtn.focus();
            }
         }
         var doc14 = document.querySelector(".product-medaia-slider-controls .glider-next");
         if (doc1 === doc14) {
            var thumbPrev = document.querySelector("#controls-thumbnails .glider-prev");
            var thumbControls = document.querySelector("#controls-thumbnails");
            if (thumbPrev && thumbControls && thumbControls.style.display !== "none") {
               event.preventDefault();
               thumbPrev.focus();
            } else if (document.querySelector(".product-thumbnails > a.tns-slide-active")) {
               event.preventDefault();
               document.querySelectorAll(".product-thumbnails > a.tns-slide-active")[0].focus();
            } else if (document.querySelector(".single-product-details > a")) {
               event.preventDefault();
               document.querySelector(".single-product-details > a").focus();
            } else if (document.querySelector(".product-vendor a")) {
               event.preventDefault();
               document.querySelector(".product-vendor a").focus();
            }
         }
         var doc15 = document.querySelector("#controls-thumbnails .glider-prev");
         if (doc1 === doc15) {
            var activeThumb = document.querySelector(".product-thumbnails > a.tns-slide-active");
            if (activeThumb) {
               event.preventDefault();
               activeThumb.focus();
            }
         }
         var docAll = document.querySelectorAll(".product-thumbnails > a.tns-slide-active");
         var doc16 = docAll[docAll.length - 1];
         if (doc1 === doc16) {
            var thumbNext = document.querySelector("#controls-thumbnails .glider-next");
            var thumbControlsEl = document.querySelector("#controls-thumbnails");
            if (thumbNext && thumbControlsEl && thumbControlsEl.style.display !== "none") {
               event.preventDefault();
               thumbNext.focus();
            } else if (document.querySelector(".single-product-details a")) {
               event.preventDefault();
               document.querySelector(".single-product-details a").focus();
            }
         }
         var doc17 = document.querySelector("#controls-thumbnails .glider-next");
         if (doc1 === doc17) {
            var detailLink = document.querySelector(".single-product-details > a");
            if (detailLink) {
               event.preventDefault();
               detailLink.focus();
            }
         }
      }
      if (document.querySelectorAll("#cart").length > 0) {
         var lastMenuItem = document.querySelector(".navbar-nav.main-menu>.menu-item:last-child>.nav-link");
         if (lastMenuItem === activeElement) {
            event.preventDefault();
            document.querySelector("#page-cart-inner #cart-fieldset .cart-items>.line-item:first-child .line-image a").focus();
         }
         document.querySelectorAll("#page-cart-inner #cart-fieldset .cart-items>.line-item").forEach(function(selfClass, index) {
            var plusBtn = selfClass.querySelector(".js-quantity-button.plus");
            if (plusBtn === activeElement) {
               var nextItem = document.querySelector("#page-cart-inner #cart-fieldset .cart-items>.line-item:nth-child(" + (index + 2) + ") .line-image a");
               if (nextItem) {
                  event.preventDefault();
                  nextItem.focus();
               }
            }
         });
      }
   }
});

// Accordion functionality
var titles = document.querySelectorAll(".faq-item-wrapper .faq-item");
var firstItem = document.querySelector(".faq-item-wrapper:first-child .faq-item");
var lastItem = document.querySelector(".faq-item-wrapper:last-child .faq-item");

function toggleFaqItem(item) {
   titles.forEach(function(faq) {
      if (item !== faq) {
         var content = faq.closest(".faq-item-wrapper").querySelector(".faq-item-content");
         content.classList.remove("show-faq-content");
         faq.closest(".faq-item-wrapper").classList.remove("border-bottom", "active-faq", "border-top");
      }
   });
   var content = item.closest(".faq-item-wrapper").querySelector(".faq-item-content");
   var wrapper = item.closest(".faq-item-wrapper");
   if (content.classList.contains("show-faq-content")) {
      content.classList.remove("show-faq-content");
      wrapper.classList.remove("border-bottom", "active-faq", "border-top");
   } else {
      content.classList.add("show-faq-content");
      wrapper.classList.add("active-faq");
      if (firstItem !== item) {
         wrapper.classList.add("border-top");
      }
      if (lastItem !== item) {
         wrapper.classList.add("border-bottom");
      }
   }
}

if (titles.length > 0) {
   titles.forEach(function(item) {
      item.onclick = function() {
         toggleFaqItem(item);
      };
   });
}

if (titles.length > 0) {
   document.addEventListener("keydown", function(event) {
      if (event.key === "Enter") {
         var activeElement = document.activeElement;
         titles.forEach(function(item) {
            var wrp = item.closest(".faq-item-wrapper");
            if (activeElement === wrp) {
               toggleFaqItem(item);
            }
         });
      }
   });
}

// Skip to content
var skipContent = document.querySelector(".skip-to-content-link");
if (skipContent != null && Shopify.designMode !== true) {
   skipContent.setAttribute("tabindex", 0);
   skipContent.style.opacity = 0;
   skipContent.focus();
}

document.addEventListener("keydown", function(event) {
   var activeElement = document.activeElement;
   setTimeout(function() {
      var searchResultLink = document.querySelector(".js-search-result-page-link");
      var searchModalOverlay = document.querySelector(".overlay-search");
      var searchResult = document.querySelector(".header-search__results");
      var searchTab = document.querySelector(".header-main__right .js-search-sidebar-link");
      var cartClose = document.querySelector(".js-close-cart");
      var searchClose = document.querySelector(".js-close-search-sidebar");
      var recSearchLastItem = document.querySelector(".search-result-recommendation li:last-child a");
      var cartTab = document.querySelector(".header-main__right .js-menu-toggle");

      var parentMenuItems = document.querySelectorAll(".menu-float__layout--primary a");
      var body = document.body;
      var menuWrapper = body.querySelector(".menu-float__wrapper");
      var menuMains = body.querySelectorAll(".menu-main");

      var sliderPrev = document.querySelectorAll(".js-slider-sites-prev");
      var sliderNext = document.querySelectorAll(".js-slider-sites-next");
      var cartNote = document.querySelector(".mini-cart-recommendations .tax-note");
      var recCartLastButton = document.querySelector(".cart-recommendations-drawer .product-card-item:last-child .button");

      var labelsFilter = document.querySelectorAll(".collection-filter-sidebar .form-check-label");
      var btnsPills = document.querySelectorAll("a.collection-filter-button,.filter-by-nav-pills li a");
      var filterClose = document.querySelector(".collection-filter-close");
      var filterApply = document.querySelector(".filter-apply-btn");
      var pillsTab = document.querySelector(".filter-by-nav-pills");

      function megamenuCloseFcn() {
         if (menuWrapper && menuWrapper.classList.contains("is-open")) {
            menuWrapper.classList.remove("is-open-main-ignore", "is-open");
            if (menuMains != null) {
               menuMains.forEach(function(item) {
                  item.classList.remove("is-active");
                  item.querySelector(".menu-float__menu-content").classList.remove("is-show");
                  item.querySelectorAll("a").forEach(function(link) {
                     link.setAttribute("tabindex", "-1");
                  });
               });
            }
         }
      }

      function megamenuEnableFcn(submenuSl) {
         var m = body.querySelector("." + submenuSl);
         menuWrapper.classList.add("is-open-main-ignore");
         setTimeout(function() {
            menuWrapper.classList.add("is-open");
         }, 0);
         if (m != null) {
            setTimeout(function() {
               m.classList.add("is-active");
            }, 0);
            setTimeout(function() {
               var content = m.querySelector(".menu-float__menu-content");
               content.classList.add("is-show");
               if (content.offsetHeight > 600) {
                  m.style.setProperty("max-height", "80vh");
               }
            }, 0);
            m.querySelectorAll("a").forEach(function(link) {
               link.setAttribute("tabindex", "0");
            });
            setTimeout(function() {
               var firstLink = m.querySelector("a:first-child");
               if (firstLink != null) {
                  firstLink.focus();
               }
            }, 0);
         }
      }

      if (event.key === "Tab" && !event.shiftKey) {
         if (searchResultLink != null && searchResultLink === activeElement) {
            searchModalOverlay.classList.remove("show-overlay", "header-search__overlay");
            searchResult.style.display = "none";
         }

         if (parentMenuItems != null) {
            var isActiveMegamenu = false;
            if (menuMains != null) {
               menuMains.forEach(function(item) {
                  if (item.classList.contains("is-active")) {
                     var firstLink = item.querySelector("a:first-child");
                     var allLinks = item.querySelectorAll("a");
                     var lastLink = allLinks[allLinks.length - 1];
                     parentMenuItems.forEach(function(currentItem, index) {
                        if (lastLink === activeElement) {
                           megamenuCloseFcn();
                           var currentSl = currentItem.dataset.childmenu;
                           if (currentSl != null && currentSl !== undefined) {
                              if (item.classList.contains(currentSl)) {
                                 var nextFocus = parentMenuItems[index + 1];
                                 if (nextFocus != null) {
                                    nextFocus.focus();
                                 }
                              }
                           }
                        }
                        if (firstLink !== activeElement && currentItem === activeElement) {
                           firstLink.focus();
                        }
                     });
                     isActiveMegamenu = true;
                  }
               });
            }
            if (!isActiveMegamenu) {
               parentMenuItems.forEach(function(item) {
                  if (item === activeElement) {
                     megamenuCloseFcn();
                     var submenuSl = item.dataset.childmenu;
                     if (submenuSl != null && submenuSl !== undefined) {
                        megamenuEnableFcn(submenuSl);
                     }
                  }
               });
            }
         }

         if (recSearchLastItem != null && activeElement === recSearchLastItem) {
            searchClose.focus();
         }

         if (cartNote != null) {
            if (activeElement === cartNote) {
               cartClose.click();
               cartTab.focus();
            }
         } else if (recCartLastButton != null) {
            if (activeElement === recCartLastButton) {
               cartClose.click();
               cartTab.focus();
            }
         }

         if (filterApply != null && pillsTab != null) {
            if (filterApply === activeElement) {
               filterClose.click();
               pillsTab.focus();
               if (labelsFilter != null) {
                  labelsFilter.forEach(function(label) {
                     label.setAttribute("tabindex", "-1");
                  });
               }
            }
         }
      }

      if (event.key === "Tab" && event.shiftKey) {
         if (menuMains != null) {
            menuMains.forEach(function(item) {
               if (item.classList.contains("is-active")) {
                  var firstLink = item.querySelector("a:first-child");
                  var allLinks = item.querySelectorAll("a");
                  var lastLink = allLinks[allLinks.length - 1];
                  parentMenuItems.forEach(function(currentItem, index) {
                     if (firstLink === activeElement) {
                        megamenuCloseFcn();
                        var currentSl = currentItem.dataset.childmenu;
                        if (currentSl != null && currentSl !== undefined) {
                           if (item.classList.contains(currentSl)) {
                              var prevFocus = parentMenuItems[index - 1];
                              if (prevFocus != null) {
                                 prevFocus.focus();
                              }
                           }
                        }
                     }
                     if (lastLink !== activeElement && currentItem === activeElement) {
                        lastLink.focus();
                     }
                  });
               }
            });
         }
         if (parentMenuItems != null) {
            parentMenuItems.forEach(function(item) {
               if (item === activeElement) {
                  megamenuCloseFcn();
               }
            });
         }

         if (filterClose != null && pillsTab != null) {
            if (filterClose === activeElement) {
               filterClose.click();
               pillsTab.focus();
               if (labelsFilter != null) {
                  labelsFilter.forEach(function(label) {
                     label.setAttribute("tabindex", "-1");
                  });
               }
            }
         }
      }

      if (event.key === "Enter") {
         if (activeElement === searchClose) {
            if (searchTab.nextElementSibling != null) {
               searchTab.nextElementSibling.focus();
            } else {
               searchTab.focus();
            }
         }
         if (activeElement === cartClose) {
            cartClose.click();
            cartTab.focus();
         }
         sliderPrev.forEach(function(btn) {
            if (btn === activeElement) {
               btn.click();
            }
         });
         sliderNext.forEach(function(btn) {
            if (btn === activeElement) {
               btn.click();
            }
         });

         var radioWraps = document.querySelectorAll(".styled-pills-radio");
         radioWraps.forEach(function(radioWrap) {
            var radios = radioWrap.querySelectorAll('input[type="radio"]');
            radios.forEach(function(radio) {
               var inputSelector = activeElement.getAttribute("for");
               if (inputSelector && activeElement.closest(".styled-pills-radio") != null) {
                  var radioToFocus = activeElement.closest(".styled-pills-radio").querySelector("#" + inputSelector);
                  if (radioToFocus === radio) {
                     radioToFocus.checked = true;
                     radioToFocus.onchange();
                  }
               }
            });
         });

         if (labelsFilter != null) {
            labelsFilter.forEach(function(label) {
               if (activeElement === label) {
                  label.click();
               }
            });
         }

         if (btnsPills != null) {
            btnsPills.forEach(function(btn) {
               if (activeElement === btn) {
                  if (filterClose != null) {
                     filterClose.focus();
                     if (labelsFilter != null) {
                        labelsFilter.forEach(function(label) {
                           label.setAttribute("tabindex", 0);
                        });
                     }
                  }
               }
            });
         }

         if (filterClose != null) {
            if (activeElement === filterClose) {
               if (pillsTab != null) {
                  pillsTab.focus();
                  if (labelsFilter != null) {
                     labelsFilter.forEach(function(label) {
                        label.setAttribute("tabindex", "-1");
                     });
                  }
               }
            }
         }
      }

      if (document.querySelectorAll(".animation-applied-element").length > 0) {
         gsap.set(".animation-applied-element", {
            clearProps: true,
         });
         if (activeElement.closest(".animation-applied-element")) {
            setTimeout(function() {
               var active = document.activeElement;
               var section = active.closest(".animation-applied-element");
               if (active.closest("body#article") == null) {
                  gsap.to(window, {
                     duration: 0.1,
                     scrollTo: {
                        y: section,
                     },
                  });
               }
            }, 0);
         }
      }

      if (document.querySelectorAll("#product").length > 0) {
         if (event.key === "Enter") {
            var addToCartBtn = document.querySelector(".single-product-details .add-to-cart-button");
            if (addToCartBtn != null && activeElement === addToCartBtn) {
               addToCartBtn.setAttribute("data-focused", true);
               document.querySelector("aside.sidebar").focus();
            }
         }
         var acc = document.querySelector(".product-info-accordion a");
         var focusedEle = document.querySelector("[data-focused]");
         if (event.key === "Enter") {
            if (activeElement === cartClose) {
               if (focusedEle != null && acc != null) {
                  acc.focus();
                  focusedEle.removeAttribute("data-focused");
               }
            }
         }
      }
   }, 5);
});
